import { render, staticRenderFns } from "./UnderWarranty.vue?vue&type=template&id=4ee55cd8&"
import script from "./UnderWarranty.vue?vue&type=script&lang=js&"
export * from "./UnderWarranty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports